

export interface Margin {
    top: number;
    right: number;
    bottom: number;
    left: number;
}


export const defaultMargin: Margin = { top: 20, right: 20, bottom: 20, left: 20 };
